export default {
  name: 'home',
  components: {
  },

  data() {
    return {
      step: 1,
      list: [],
      datas: {},
      showMores: true,
      params: {
        order_num: '',
        name: '',
        img: ''
      },
      code: '',
      localIds: '',
      shows: false,
      showMsg: '',
      codeImg: '',
      resCode: '',
      showFinish:false,
      dataMes:{},
    }
  },
  created() {

    // console.log('window.location.href===' + window.location.href)
  },
  mounted: function () {
    // this.getConfig();
    // this.testLogin();
    if (this.$route.query.code) {
      this.getInfo(this.$route.query.code)
    } else {
      // this.apiGet("/h5/api/user/getUserInfo", '', res => {
      //   if (res.state) {
      //     sessionStorage.setItem('loginInfo', res.data);
      //   } else {
      //     this.$message({
      //       message: res.msg,
      //     });
      //   }
      // });
    }
  },
  methods: {
      finishs(){
      this.resets()
      this.code = ''
      this.showFinish=false;
    },
    getConfig(){
      this.apiGet('/h5/api/common/getWxConfig', {}, res => {
        if (res.state) {
       
        } else {
        }
      })
    },
    testLogin(){
      
      this.apiGet('/h5/api/weixin/auth/testLogin', {}, res => {
        if (res.state) {
          sessionStorage.setItem('token', res.data)
          sessionStorage.setItem('loginInfo', JSON.stringify(res.data))
          // window.location.href = '/home'
        } else {
        }
      })
    },
    closeShows: function() {
      this.shows = false
      if (this.showMsg == '此口令不存在，请输入正确口令！') {
        this.params.order_num = ''
      }
    },
    tixian: function () {
      this.shows = false
      this.$router.push({ path: '/accountList' })
    },
    toPages: function (url) {
      this.$router.push({ path: url })
    },
    delImg: function () {
      this.params.img = ''
      this.localIds = ''
    },
    toHb: function () {
      this.$message('正在开发')
    },
    toLinks: function () {
      this.$router.push({ path: '/links' })
    },
    upImg: function () {
      let that = this
      wx.checkJsApi({
        jsApiList: ['chooseImage'],
        success: function (res) {
          wx.chooseImage({//
            count: 1, // 默认9
            sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: function (res) {
              that.localIds = res.localIds[0]
              let localId = res.localIds[0]// 获取到本地localIds
              wx.uploadImage({// 上传到微信服务器
                localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success: function (ret) {
                  that.params.img = ret.serverId
                }
              })
            }
          })
        }
      })
    },
    saves: function () {
      if (!this.params.order_num) {
        this.$message('请填写或复制黏贴红包口令')
        return
      }
      if (this.code == '1005') {
        if (!this.params.name) {
          this.$message('请输入姓名')
          return
        }
        if (!this.params.img) {
          this.$message('请上传图片')
          return
        }
      }

      if (this.code == '1006') {
        if (!this.params.name) {
          this.$message('请输入姓名')
          return
        }
      }
      if (this.code == '1007') {
        if (!this.params.img) {
          this.$message('请上传图片')
          return
        }
      }
      // if (this.code == '1008') {
      //   this.$confirm('没有绑定支付宝,请绑定支付宝', '提示', {
      //     confirmButtonText: '去绑定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$router.push({ path: '/bindAli?type=2' });
      //   }).catch(() => { });
      // }
      this.params.bid = localStorage.getItem('bid')
      this.apiGet('/h5/api/activity/submitCode', this.params, res => {
        if (res.code != 0) {
          this.code = res.code
        }
        let status = true
        if (this.code == '1008') {
          status = false
          this.$confirm('没有绑定支付宝,请绑定支付宝', '提示', {
            confirmButtonText: '去绑定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({ path: '/bindAli?type=2' })
          }).catch(() => { })
        }

        if (res.state) {
          if (!status) {
            return
          }
          this.dataMes=res;
          this.showFinish=true;
          // this.$alert(`<div style="font-size:18px;line-height:30px;color:red;">${res.msg}</div>`, '', {
          //   dangerouslyUseHTMLString: true,
          //   confirmButtonText: '确定',
          //   callback: action => {
          //     this.resets()
          //     this.code = ''
          //   }
          // })
        } else {
          this.resCode = res.code
          // if(res.code!='40008'&&res.code!='1030'){
          //   this.showMsg = res.msg;
          // }else{
          if (res.msg.indexOf('请联系客服微信') != '-1') {
            let data = res.msg.split('：')
            this.showMsg = data[0]
            this.codeImg = data[1]
          } else {
            this.showMsg = res.msg
          }

          // }
          if (res.code != '1008') {
            this.shows = true
          }
        }
      })
    },
    toMy: function () {
      this.$router.push({ path: '/my' })
    },
    getInfo: function (code) {
      this.apiGet('/h5/api/weixin/auth', { code: code }, res => {
        if (res.state) {
          sessionStorage.setItem('token', res.data)
          sessionStorage.setItem('loginInfo', JSON.stringify(res.data))
          window.location.href = '/home'
        } else {
        }
      })
    },
    resets: function () {
      this.params.img = ''
      this.params.name = ''
      this.params.order_num = ''
      this.localIds = ''
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/home/home.js